import {
  KycApplicationStatus,
  KycStatus,
  LivelinessStatus,
  UserProfile,
} from '@shared/types/user'

export type ParsedKycStatus = {
  kycApplicationStatus: `${KycApplicationStatus}` | 'Never Submitted'
  kycLivelinessStatus: `${LivelinessStatus}` | null
  status: KycStatus
}

const parseKycStatus = (status?: KycStatus): ParsedKycStatus => {
  if (!status) {
    return {
      status: 'Never Submitted',
      kycApplicationStatus: 'Never Submitted',
      kycLivelinessStatus: null,
    }
  }

  const [kycApplicationStatus, kycLivelinessStatus] = status.split('|')

  return {
    status,
    kycApplicationStatus: kycApplicationStatus as KycApplicationStatus,
    kycLivelinessStatus: kycLivelinessStatus as LivelinessStatus,
  }
}

const APPLICATION_STATUSES_THAT_NEED_VERIFICATION: ParsedKycStatus['kycApplicationStatus'][] =
  ['Expired', 'MissingInfo', 'New', 'Rejected', 'Never Submitted']

const LIVELINESS_STATUSES_THAT_NEED_VERIFICATION: ParsedKycStatus['kycLivelinessStatus'][] =
  ['Failed', 'Incomplete', 'NotStarted']

const getNeedsVerfication = ({
  kycApplicationStatus,
  status,
  kycLivelinessStatus,
}: ParsedKycStatus) => {
  const needsVerification =
    APPLICATION_STATUSES_THAT_NEED_VERIFICATION.includes(
      kycApplicationStatus,
    ) ||
    LIVELINESS_STATUSES_THAT_NEED_VERIFICATION.includes(kycLivelinessStatus)

  return needsVerification ?? status === 'Never Submitted'
}

export const getKYCState = (accountData?: UserProfile | null) => {
  const data = accountData

  // NOTE: Return more kyc related fields if needed
  const approvalLevel = Number(data?.kycApprovedLevel ?? 0)
  const type = data?.kycType
  const statuses = parseKycStatus(data?.kycStatus)
  const hasKYC = approvalLevel > 0
  const needsVerification = getNeedsVerfication(statuses)

  return {
    hasKYC,
    needsVerification,
    statuses,
    //  NOT USED YET
    type,
    approvalLevel,
  }
}

const APPLICATION_STATUSES_WITH_USER_DETAILS: ParsedKycStatus['kycApplicationStatus'][] =
  ['Approved', 'Submitted', 'Pending']

export const getHasSubmittedUserDetailsToKYC = (statuses: ParsedKycStatus) => {
  return APPLICATION_STATUSES_WITH_USER_DETAILS.includes(
    statuses.kycApplicationStatus,
  )
}
